/**
 *
 * FlashCardLanding
 *
 */

import { FlashCardBookMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardBookMixin';
import FlashCardItem from '@/views/FlashCard/FlashCardLanding/components/FlashCardItem.vue';

export default {
  name: 'FlashCardBook',

  mixins: [FlashCardBookMixin],

  components: {
    FlashCardItem,
  },
};
